export const DependencyTypes = {
  FS: "FS",
  SS: "SS",
  FF: "FF",
  SF: "SF"
};
